// @flow
import React, { useState } from 'react';
import ArticleFactCheckingDialog from './ArticleFactCheckingDialog';

type Props = {
	factChecking: ?string,
};

const linkStyle = {
	color: '#542376',
	cursor: 'pointer',
	textDecoration: 'underline',
	fontSize: 13,
	whiteSpace: 'nowrap',
	border: 'none',
	background: 'none',
	padding: 0,
	marginLeft: 12,
};

/**
 * Ссылка «Результаты фактчекинга» рядом с подписью поля текста материала.
 * Показывается только при наличии непустого результата.
 */
export default function ArticleBodyFactCheckingLink({ factChecking }: Props) {
	const [open, setOpen] = useState(false);
	const text =
		factChecking != null && factChecking.trim() !== '' ? factChecking : null;

	if (text == null) {
		return null;
	}

	return (
		<span>
			<button type="button" style={linkStyle} onClick={() => setOpen(true)}>
				Результаты фактчекинга
			</button>
			<ArticleFactCheckingDialog
				open={open}
				onRequestClose={() => setOpen(false)}
				content={text}
			/>
		</span>
	);
}



// WEBPACK FOOTER //
// src/components/articles/ArticleBodyFactCheckingLink.js